import React from "react";
import { Link } from "react-router";
import foodstarterGuide from "./faq/assets/StartHubGuide.pdf";
import foodstarterGuideEn from "./faq/assets/StartHubGuideEn.pdf";
import roadmap from "../assets/roadmap.jpg";
import hero from "../assets/hero.jpg";

const Welcome = () => {
  return (
    <div className="welcome-page-2">
      <div className="bottom">
        <img
          style={{
            display: "block",
            margin: "0 auto",
            maxWidth: "600px",
            width: "90vw",
          }}
          src={hero}
          alt="Hero banner"
        />
        <section>
          <h3 className="body-title">FAQs</h3>
          <p className="body-subtitle">
            Die am häufigsten gestellten Fragen zusammengefasst
          </p>
          <div className="faq-link-wrapper">
            <Link className="link-to-faq" to="/faq/pricing">
              Gebührenmodell
            </Link>
            <Link className="link-to-faq" to="/faq/marketing">
              Marketing
            </Link>
            <Link className="link-to-faq" to="/faq/qs">
              Qualitätssicherung
            </Link>
            <Link className="link-to-faq" to="/faq/billing">
              Rechnungsstellung
            </Link>
            <Link className="link-to-faq" to="/faq/changes">
              Änderungen
            </Link>
          </div>
          <h3 className="body-title">EDEKA StartHub Guide</h3>
          <p className="body-subtitle">
            Relevantes Branchenwissen kombiniert mit einer EDEKA StartHub
            Checkliste für Deinen Start
          </p>
          <a className="download-link" download href={foodstarterGuide}>
            Download Guide (DE)
          </a>
          <a className="download-link" download href={foodstarterGuideEn}>
            Download Guide (EN)
          </a>
          <h3 className="body-title">Was erwartet mich?</h3>
          <p className="body-subtitle">
            Alle Schritte von Registrierung bis zur Produktveröffentlichung
          </p>
          <Link to={roadmap} target="_blank">
            <img
              className="roadmap"
              src={roadmap}
              alt="EDEKA StartHub's roadmap"
            />
          </Link>
        </section>

        <hr />
        {/* SnapWidget */}
        {/* <!-- SnapWidget --> */}
        <script src="https://snapwidget.com/js/snapwidget.js" />
        <h3 className="our-community">Unsere Community</h3>
        <div className="widget-wrapper">
          <script src="https://snapwidget.com/js/snapwidget.js" />
          <iframe
            title="Instagram"
            src="https://snapwidget.com/embed/947247"
            className="snapwidget"
            // eslint-disable-next-line react/no-unknown-property
            allowtransparency="true"
            frameBorder="0"
            scrolling="no"
          />
        </div>
      </div>
    </div>
  );
};

export default Welcome;
